import * as React from "react";
import {observer} from "mobx-react";
import isRetina from "is-retina"
import ProductCard from "@components/Products/ProductCard";
import TopFilterToolbar from "@components/Toolbar/TopFilterToolbar";
import ReactStickySidebar from "@components/ReactStickySidebar/ReactStickySidebar";
import StickySidebar from "../ReactStickySidebar/sticky-sidebar";

@observer
export default class BerikssonCategoryGrid extends React.Component {
    constructor(props) {
        super(props);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.getProductUrl = this.getProductUrl.bind(this);

        //this.getControlHeightRatio = this.getControlHeightRatio.bind(this);
        this.increaseQuantities = this.increaseQuantities.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.handleMinimized = this.handleMinimized.bind(this);
    
        this.initStickyProducts = this.initStickyProducts.bind(this);
        this.updateStickyProducts = this.updateStickyProducts.bind(this);

        this.state = {
            adding: null,
            isLoading: false,
            hasMore: true,
            resizeToggle: false
        };
    }

    handleMinimized() {
        //console.log("Minimzed!");
        this.setState({resizeToggle: !this.state.resizeToggle});
    }

    getProductUrl(product) {
        return this.props.navigation.getProductUrl(product);
    }

    openProductDialog(e, product, listIndex) {
        e.preventDefault();
        this.props.navigation.openProductDialog(product, {listIndex: listIndex});
    }

    increaseQuantities(e, changes) {
        e.preventDefault();
        clearTimeout(this.timer);
        this.setState({adding: changes[0].Sku});
        const orderStore = this.props.store.order;
        const result = orderStore.increaseQuantities(changes);

        this.timer = setTimeout(() => {
                this.setState({adding: null});
            },
            2000);
    }

    // getControlHeightRatio(model) {
    //
    //     if (!model.value || !model.editor || !model.editor.name) return 1; // Early out..
    //
    //     //const url = model.value.src;
    //     const editorName = model.editor.name; // Box, Hero, Product
    //
    //     // 1. filter crop
    //     const {isMobile} = this.props;
    //
    //     const crops = model.value.crops && model.value.crops.filter(x => x.alias.startsWith(editorName));
    //
    //     if (!crops) return 1;
    //
    //     // 2. use mobile breakpoints
    //     // todo: find the picked/configured crop, not the first
    //     const aliasToFind = isMobile ? "Mobile" : "Desktop";
    //     const crop = crops.find(x => x.alias.indexOf(aliasToFind) >= 0);
    //
    //     if (crop) {
    //         return crop.height / crop.width;
    //     }
    //
    //     return 1;
    // }

    componentDidMount() {
        const serverRender = typeof window === 'undefined';
        if (serverRender) return;
        this.previousQuery = this.props.store.navigation.getQueryFromLocation();

        this.initStickyProducts();
    }


    loadMore() {
        const navigation = this.props.navigation;
        //console.log("loadMore..", navigation.products.length);

        const nrOfProducts = navigation.products.length;
        this.setState(state => ({
            isLoading: true
        }));
        navigation.GetContent("infinite", null, navigation.products.length).then(() => {
            //const hasMore = nrOfProducts !== navigation.products.length;
            
            this.setState(state => ({
                //hasMore: hasMore,
                isLoading: false,
                resizeToggle: !this.state.resizeToggle
            }));
        });
    }

    initStickyProducts() {
        if (this.stickyProducts) {
            this.stickyProducts.destroy();
        }
        this.stickyProducts = new StickySidebar(this.productsStickyRef, { innerWrapperSelector: '.sticky-products__inner', topSpacing: this.productsStickyRef.offsetTop, bottomSpacing: 30 });
    }

    updateStickyProducts() {
        if (this.stickyProducts) {
            this.stickyProducts.updateSticky();
        }
    }

    render() {
        //this.props.resetProductIterator();

        const navigation = this.props.navigation;

        const products = navigation.ProductsView;

        // Server?
        const serverRender = typeof window === 'undefined';
        //serverRender && console.debug("render products: ", products);
        
        const gridJson = this.props.model;
        //const topGrid = this.props.topGrid;
        //console.debug("grid:", gridJson, this.props.navigation.viewPortWidth);
        if (!gridJson || !gridJson.sections) return (<div>Error: Content not found</div>);
        

        // is retina?
        const retina = isRetina();
     
        const isProductModalOpen = this.props.store.navigation.isProductModalOpen;

        const toolbarOpen = this.props.store.navigation.isToolbarOpen;
        //console.log("hasMore", navigation.products.length < navigation.totalResults, navigation.totalResults);

        const headerName = this.props.headerName;

        const imageWidth = 800;
        const hasMore = navigation.products.length < navigation.totalResults;

        return (
            <div>
                {/*<h1 className="top-filter-header">{headerName}</h1>*/}
                <div className="top-filter-container">
                    <TopFilterToolbar headerName={headerName} handleMinimized={this.handleMinimized}/>
                </div>
                <div className="row">
                    <div className="left-filter-bar hidden-md-down">
                        <ReactStickySidebar initTrigger={this.state.resizeToggle} onSideBarUpdate={this.updateStickyProducts}
                        />
                        {/*initTrigger={isProductModalOpen}*/}
                    </div>

                    <div className="product-grid-container col">
                        <div className="products-sticky" ref={el => this.productsStickyRef = el}>
                            <div className="products-stick__inner">
                                {this.props.children}
                                {navigation.products && navigation.products.length === 0
                                    ? <div className={"text-center"}><h5>** Inga produkter hittades **</h5>
                                        {navigation.ActiveCustomerType === "pending" ?
                                            <div>Det aktiva kundkontot är inte aktiverat. Kontakta kundtjänst</div> : null}
                                    </div>
                                    : null
                                }

                                <div className={"product-container " + (toolbarOpen ? " toolbar-open" : "")}>

                                    {navigation.products.map((product, areaIndex) => {
                                            return (
                                                <div className="grid-card" key={product.Sku}>
                                                    <div className={"product-outer"}>
                                                        <div className="product-card">
                                                            <ProductCard
                                                                product={product}
                                                                orderStore={this.props.store.order}
                                                                navigation={this.props.store.navigation}
                                                                listIndex={areaIndex}
                                                                imageWidth={imageWidth}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>);
                                        }
                                    )}
                                </div>
                       

                        {hasMore ?
                            <div key={'load-more'} className="row">
                                <div className="col-12" style={{textAlign: "center"}}>
                                    <button className="load-more-button"
                                            onClick={() => this.loadMore()}>{navigation.dictionary.LoadMore}</button>
                                    <div>{navigation.products.length} av {navigation.totalResults}</div>
                                </div>
                            </div>
                            : null
                        }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
